import { Injectable } from '@angular/core';
import { MatFormFieldAppearance } from '@angular/material/form-field';
import { AppSettingService } from '@rd/core/services/app-setting/app-setting.service';

@Injectable({
  providedIn: 'root',
})
export class VmaAppSettingService extends AppSettingService {
  matFormFieldAppearance = 'fill' as MatFormFieldAppearance;
}
